import { render } from "./SemanasLista.vue?vue&type=template&id=39dcb802&scoped=true"
import script from "./SemanasLista.vue?vue&type=script&lang=js"
export * from "./SemanasLista.vue?vue&type=script&lang=js"

import "./SemanasLista.vue?vue&type=style&index=0&id=39dcb802&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39dcb802"]])

export default __exports__